import { Colors } from '@sigma-frontend-libs/commons'

export const FILE_TYPES = {
  doc: {
    value: 'doc',
    title: 'misc.fileTypes.documents',
    color: Colors['file-document'],
    ext: 'doc, docx',
    extensions: [ 'doc', 'docx' ]
  },
  csv: {
    value: 'csv',
    title: 'misc.fileTypes.tables',
    color: Colors['file-sheet'],
    ext: 'xls, xlsx, csv',
    extensions: [ 'xls', 'xlsx', 'csv' ]
  },
  pdf: {
    value: 'pdf',
    title: 'misc.fileTypes.pdf',
    color: Colors['file-pdf'],
    ext: 'pdf',
    extensions: [ 'pdf' ]
  },
  jpg: {
    value: 'jpg',
    title: 'misc.fileTypes.images',
    color: Colors['file-image'],
    ext: 'jpg, jpeg, png, gif',
    extensions: [ 'jpg', 'jpeg', 'png', 'gif' ]
  },
  wav: {
    value: 'wav',
    title: 'misc.fileTypes.audio',
    color: Colors['file-audio'],
    ext: 'wav, mp3',
    extensions: [ 'wav', 'mp3' ]
  },
  mp4: {
    value: 'mp4',
    title: 'misc.fileTypes.video',
    color: Colors['file-video'],
    ext: 'mp4',
    extensions: [ 'mp4' ]
  },
  file: {
    value: 'file',
    color: Colors.file,
    ext: '*',
    extensions: []
  }
}
